import fs from 'node:fs'
import path from 'node:path'

export function hasTsconfigAdminAliases(cwd: string, namespace: string): boolean {
  const tsconfigPath = path.join(cwd, 'tsconfig.json')
  if (!fs.existsSync(tsconfigPath)) return false

  try {
    const content = fs.readFileSync(tsconfigPath, 'utf-8')
    return content.includes(`@${namespace}/`)
  } catch {
    return false
  }
}
